import Page from '@admin/components/page'
import Overview from './overview'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.participant.contact.display_name,
  manager: {
    path: `/admin/truevail/admin/webinars/${resources.webinar.id}/participants/${resources.participant.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview webinar={ resources.webinar } participant={ resources.participant } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  webinar: `/api/admin/truevail/admin/webinars/${props.params.webinar_id}`,
  participant: `/api/admin/truevail/admin/webinars/${props.params.webinar_id}/participants/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
